
const actions = {

}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/home/actions.js